import { ContentTag, provideComponent } from 'scrivito'

import { Homepage } from './HomepageObjClass'

provideComponent(Homepage, ({ page }) => (
  <ContentTag tag="div" id="main" content={page} attribute="body" />
))
